import { Size } from '@ui/selects/SizeSelect'
import {
  ICostCenter,
  IGlobalMapObject,
  IDepartment,
  IHRLocation,
  IUsageType,
  ISpaceType,
  IBuilding,
  IFloor,
  IAssignmentPlan,
  IEmployee,
} from '@api'

export enum GROUP_TYPES {
  CHART = 'chart',
  TABLE = 'table',
  TABLE_FOOTER = 'table_total',
  STATS_TABLE = 'stats_table',
  SUMMARY_TABLE = 'summary_table',
}

export enum CHART_TYPES {
  SBAR = 'stacked_bar',
  VERTICAL_BAR = 'vertical_bar',
  HORIZONTAL_BAR = 'horizontal_bar',
  DONUT = 'bagel',
  HEATMAP = 'heatmap',
}

export interface IGroup {
  columns: string[]
  columnTypes: string[]
  name: string
  type: string
  chartType: string | null
  values: string[][]
  tooltip: string[]
}

export interface IReportFilters {
  spaceId?: string
  assignmentPlan?: IAssignmentPlan
  departmentId?: IDepartment[]
  city?: string[]
  buildingId?: IBuilding[]
  floorId?: IFloor[]
  spaceTypeId?: ISpaceType[]
  usageTypeId?: IUsageType[]
  employmentType?: string[]
  globalMapObjectId?: IGlobalMapObject[]
  site?: IHRLocation[]
  costCenterId?: ICostCenter[]
  size?: Size[]
  region?: string[]
  country?: string[]
  fromDate?: string
  toDate?: string
  location?: string[]
  calculateForYear?: number
  employees?: IEmployee[]
  isCancelled?: boolean
}

export interface IReport {
  id: string
  name: string
  hidden: boolean
  categoryName: string
  newReport: boolean
  description: string
}

export interface IReportDefinition {
  categories: string[]
  byCategory: IByCategory
  reports: IReport[]
  availableReports: string[]
}

export interface IByCategory {
  [name: string]: IReport[]
}

export interface ITooltip {
  name: string
  description: string
}
